import React, { useCallback, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import bookingSelectors from 'store/selectors/booking'
import projectSelectors from 'store/selectors/project'
import bookingActions from 'store/modules/booking'
import routerSelectors from 'store/selectors/router'
import routerActions from 'store/modules/router'

import Template from 'shared/src/template'

import FormPage from './FormPage'

const BookingFormCustomize = ({
  
}) => {

  const dispatch = useDispatch()
  const slot = useSelector(bookingSelectors.slot)
  const initialValues = useSelector(bookingSelectors.optionsValues)
  const allSchema = useSelector(bookingSelectors.optionsSchema)
  const formConfig = useSelector(bookingSelectors.slotFormConfig)
  const stripeConnect = useSelector(projectSelectors.currentProjectStripeConnect)

  const schema = useMemo(() => {
    return allSchema
      .filter(item => {
        if(typeof(item.admin) !== 'boolean') return true
        return !item.admin
      })
  }, [
    allSchema
  ])

  const {
    project,
    bookingform,
  } = useSelector(routerSelectors.params)

  const validate = useCallback((values) => {
    if(!slot.templates || !slot.templates.validate) return {}
    const template = Template({
      slot,
      config: formConfig,
      options: values,
    })
    const errors = template(slot.templates.validate, 'slot.templates.validate') || {}
    return errors
  }, [
    slot,
    formConfig,
  ])

  const onBack = useCallback(() => {
    dispatch(routerActions.navigateTo('book.form.calendar', {
      project,
      bookingform,
      date: slot.date,
    }))
  }, [
    project,
    bookingform,
    slot,
  ])

  const onSubmitForm = useCallback(async (payload, direction) => {
    const result = await dispatch(bookingActions.updateReservation({
      options: payload,
    }))
    if(result) {
      dispatch(bookingActions.setOptions(payload))
      dispatch(routerActions.navigateTo('book.form.details', {
        project,
        bookingform,
      }))
    }
  }, [
    project,
    bookingform,
    slot,
  ])

  // redirect to calendar if there is no slot already picked
  useEffect(() => {
    if(slot) return
    dispatch(routerActions.navigateTo('book.form.calendar', {
      project,
      bookingform,
      date: 'today',
    }))
  }, [
    project,
    bookingform,
    slot,
  ])

  useEffect(() => {
    if(formConfig) return
    if(!slot) return
    dispatch(bookingActions.loadCalendarConfig({
      project,
      bookingform,
    }))
  }, [
    project,
    bookingform,
    formConfig,
  ])

  if(!slot) return null
  if(!formConfig) return null
  
  return (
    <FormPage
      withAlert={ stripeConnect ? false : true }
      schema={ schema }
      initialValues={ initialValues }
      validate={ validate }
      onBack={ onBack }
      onSubmit={ onSubmitForm }
    />
  )
}

export default BookingFormCustomize